"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.genericScrollTo = exports.getScrollLeft = exports.getScrollTop = exports.getScrollHeight = exports.getScrollWidth = void 0;
const seamless_scroll_1 = require("../../seamless-scroll");
const cache_1 = require("../cache");
const getScrollWidth = (element) => {
    if (element === document.body) {
        return (0, cache_1.getCachedInnerWidth)();
    }
    else {
        return (0, cache_1.getCachedScrollWidth)(element);
    }
};
exports.getScrollWidth = getScrollWidth;
const getScrollHeight = (element) => {
    if (element === document.body) {
        return (0, cache_1.getCachedScrollHeight)(document.documentElement);
    }
    else {
        return (0, cache_1.getCachedScrollHeight)(element);
    }
};
exports.getScrollHeight = getScrollHeight;
const getScrollTop = (element) => {
    if (element === document.body) {
        return (0, cache_1.getCachedScrollY)();
    }
    else {
        return (0, cache_1.getCachedScrollTop)(element);
    }
};
exports.getScrollTop = getScrollTop;
const getScrollLeft = (element) => {
    if (element === document.body) {
        return (0, cache_1.getCachedBodyScrollLeft)();
    }
    else {
        return (0, cache_1.getCachedScrollLeft)(element);
    }
};
exports.getScrollLeft = getScrollLeft;
const genericScrollTo = (element, top, left, instant) => {
    if (element === document.body) {
        (0, seamless_scroll_1.windowScroll)({ behavior: instant ? 'auto' : 'smooth', top, left });
    }
    else {
        (0, seamless_scroll_1.elementScroll)(element, { behavior: instant ? 'auto' : 'smooth', top, left });
    }
    (0, cache_1.clearCache)();
};
exports.genericScrollTo = genericScrollTo;
//# sourceMappingURL=data:application/json;base64,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